import { useState, ReactNode } from "react"

import { motion } from "framer-motion"
import { X } from "lucide-react"

import { ActionTooltipButton } from "@components/buttons/ActionTooltipButton"
import { DocumentPanel } from "@components/panels/DocumentPanel"

interface DocumentOverlayProps {
    children: ReactNode
    document: string
}
export function DocumentOverlay({ children, document }: Readonly<DocumentOverlayProps>) {
    const [isOpen, setIsOpen] = useState(false)

    const handleClick = () => {
        setIsOpen(true)
    }

    return (
        <div className="flex items-center justify-center w-full">
            <div onClick={handleClick} className="w-full align-left">
                {children}
            </div>

            {isOpen && (
                <div className="z-45 fixed w-full inset-0 bg-opacity-50 flex justify-end top-[var(--header-height)]">
                    <motion.div initial={{ x: "100%" }} animate={{ x: 0 }} exit={{ x: "100%" }} transition={{ type: "spring", stiffness: 300, damping: 30 }} className="w-80 h-full w-full bg-white shadow-lg p-0 relative">
                        <DocumentPanel id={document}>
                            <ActionTooltipButton icon={<X />} variant="default" tooltip="Close overlay" onClick={() => setIsOpen(false)} />
                        </DocumentPanel>
                    </motion.div>
                </div>
            )}
        </div>
    )
}
